import React from 'react'
import PropTypes from 'prop-types'
import BEMHelper from '@ynap/bem-helper'
import Address from '@ynap/address'
import Skeleton from '@ynap/skeleton'
import PaymentCard from '@ynap/payment-card'

const bem = new BEMHelper('OrderPaymentSummary')

const propTypes = {
    messages: PropTypes.shape({
        orderPaymentSummary: PropTypes.shape({
            shippedTo: PropTypes.func.isRequired,
            shippingMethod: PropTypes.func.isRequired,
            billedTo: PropTypes.func.isRequired,
            shippingMethodName: PropTypes.func.isRequired,
            paymentType: PropTypes.func.isRequired,
        }),
        total: PropTypes.string.isRequired,
    }),
    paymentMethod: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string,
            type: PropTypes.string,
            cardNumber: PropTypes.string,
        })
    ),
    shippingAddress: PropTypes.object,
    shippingMethod: PropTypes.array,
    className: PropTypes.string,
}

function OrderPaymentSummary({ className, messages, shippingAddress, shippingMethod, paymentMethod }) {
    return (
        <div className={bem(null, null, className)}>
            <div className={bem('item')}>
                <div className={bem('title')}>{messages.orderPaymentSummary.shippedTo()}</div>
                {shippingAddress ? (
                    <Address className={bem('info', 'address')} {...shippingAddress} />
                ) : (
                    <Skeleton count={3} align="left" />
                )}
            </div>

            <div className={bem('item')}>
                <div className={bem('title')}>{messages.orderPaymentSummary.shippingMethod()}</div>
                {shippingMethod.length ? (
                    <div className={bem('info', 'shippingMethod')}>
                        {shippingMethod.map((method) => (
                            <div key={method}>
                                {messages.orderPaymentSummary.shippingMethodName({
                                    method,
                                    country: shippingAddress?.country?.toUpperCase(),
                                })}
                            </div>
                        ))}
                    </div>
                ) : (
                    <Skeleton count={3} align="left" />
                )}
            </div>

            <div className={bem('item')}>
                <div className={bem('title')}>{messages.orderPaymentSummary.billedTo()}</div>
                {paymentMethod ? (
                    paymentMethod.map((paymentItem) => (
                        <div key={paymentItem.id ?? paymentItem.type} className={bem('info', 'paymentMethod')}>
                            {(paymentItem.type === 'CREDIT_CARD' && paymentItem.subType) ||
                            paymentItem.type.match(
                                /^(PAYPAL|APPLEPAY|KLARNA_PAY_NOW|KLARNA_PAY_LATER|KLARNA_SLICE_IT)$/
                            ) ? (
                                <>
                                    <PaymentCard
                                        className={bem('cardType', paymentItem.type?.replace(/_/g, '')?.toLowerCase())}
                                        card={paymentItem.subType || paymentItem.type?.replace(/_/g, '')?.toLowerCase()}
                                        key={paymentItem.subType || paymentItem.type?.replace(/_/g, '')?.toLowerCase()}
                                    />
                                    <div className={bem('paymentType')}>
                                        {paymentItem.type.match(/^KLARNA\w*$/) &&
                                            messages.orderPaymentSummary.paymentType({ type: paymentItem.type })}
                                    </div>
                                </>
                            ) : (
                                <div className={bem('paymentType')}>
                                    {messages.orderPaymentSummary.paymentType({ type: paymentItem.type })}
                                </div>
                            )}
                            <div className={bem('paymentCardNumber', paymentItem.cardNumber ? 'dotPrefix' : null)}>
                                {paymentItem.cardNumber}
                            </div>
                            <div className={bem('paymentTotal')}>{paymentItem.total}</div>
                        </div>
                    ))
                ) : (
                    <Skeleton count={3} align="left" />
                )}
            </div>
        </div>
    )
}

OrderPaymentSummary.propTypes = propTypes

export default OrderPaymentSummary
